import { useState, useEffect, useRef } from 'react';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import MaterialGroup from '../../models/MaterialGroup';
import { MaterialGroupService } from '../../service/MaterialGroupService';
import { FilterMatchMode } from 'primereact/api';
import { Card } from 'primereact/card';

const MaterialGroupView = () => {
    const [materialGroups, setMaterialGroups] = useState<MaterialGroup[]>([]);
    const [loadingMaterialGroups, setLoadingMaterialGroups] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const [filters, setFilters] = useState<DataTableFilterMeta>({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const dtMaterialGroups = useRef<any>(null);

    useEffect(() => {
        MaterialGroupService.getMaterialGroups().then(data => {
            setMaterialGroups(data);
            setLoadingMaterialGroups(false);
        });
    }, []);

    const materialGroupBodyTemplate = (rowData: MaterialGroup) => {
        return rowData.materialGroup;
    }

    const descriptionBodyTemplate = (rowData: MaterialGroup) => {
        return rowData.description;
    }

    const description2BodyTemplate = (rowData: MaterialGroup) => {
        return rowData.description2;
    }

    const isAutoScheduledBodyTemplate = (rowData: MaterialGroup) => {
        if (rowData.isAutoScheduled) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    }

    const isDualRouteBodyTemplate = (rowData: MaterialGroup) => {
        if (rowData.isDualRoute) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    }

    const bsnLetteringTypeBodyTemplate = (rowData: MaterialGroup) => {
        return rowData.bsnLetteringType;
    }

    const isMultipleAllowedBodyTemplate = (rowData: MaterialGroup) => {
        if (rowData.isMultipleAllowed) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    }

    const exportMaterialGroups = () => {
        dtMaterialGroups.current.exportCSV();
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export" onClick={(e) => {exportMaterialGroups(); e.stopPropagation();}} />
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Card className="layout-main-card border-noround">
                    <DataTable ref={dtMaterialGroups} value={materialGroups}
                        dataKey="id" size="small" rowHover={true} loading={loadingMaterialGroups}
                        scrollable scrollHeight="calc(100vh - 14.6rem)"
                        paginator rows={25} rowsPerPageOptions={[5, 10, 25]} 
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} material groups"
                        filters={filters} emptyMessage="No material groups found." header={header}>
                        <Column field="materialGroup" header="Material Group" body={materialGroupBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="description" header="Description" body={descriptionBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="description2" header="Description 2" body={description2BodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="isAutoScheduled" header="Is Auto Scheduled" body={isAutoScheduledBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="isDualRoute" header="Is Dual Route" body={isDualRouteBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="bsnLetteringType" header="BSN Lettering Type" body={bsnLetteringTypeBodyTemplate} align="center" alignHeader="center"></Column>
                        <Column field="isMultipleAllowed" header="Is Multiple Allowed" body={isMultipleAllowedBodyTemplate} align="center" alignHeader="center"></Column>
                    </DataTable>
                </Card>
            </div>
        </div>
    );
}

export default MaterialGroupView;